import React from 'react'
import { Stack } from '@sureco/design-system'
import Text from '@hixme-ui/text'
import { BookOutlined } from '@ant-design/icons'
import { DownloadButton } from '../../components/DownloadButton'
import { API_ACTIVITY_STATUS, API_ACTIVITY_TYPE } from './enum'
import {
  CencusApiActivityDataResponseDto,
  CencusApiActivityStatusType,
  CencusApiActivityDataType,
} from './types'
import dayjs from 'dayjs'
import { Tooltip } from '@surecompanies/core_components'

const isCompleted = (status: CencusApiActivityStatusType): boolean => {
  return status === API_ACTIVITY_TYPE.SYNC_COMPLETED
}

const isInProgress = (status: CencusApiActivityStatusType): boolean => {
  return status === API_ACTIVITY_TYPE.SYNC_IN_PROGRESS
}

const isError = (status: CencusApiActivityStatusType): boolean => {
  return status === API_ACTIVITY_TYPE.SYNC_ERROR
}

export const columns = [
  {
    title: (
      <Stack direction="row" align="center" space={10}>
        <BookOutlined />
        <Text bold>Customer</Text>
      </Stack>
    ),
    dataIndex: 'customer',
  },
  {
    title: 'Time Received',
    dataIndex: 'timeReceived',
    render: (date: string) => {
      if (!date) return '-'
      return dayjs(date).format('M/D/YYYY - h:mmA')
    },
  },
  {
    title: 'Time Processed',
    dataIndex: 'timeProcessed',
    render: (
      date: string,
      {
        status,
        description,
      }: Pick<CencusApiActivityDataResponseDto, 'status' | 'description'>
    ) => {
      if (isError(status)) {
        return (
          <Tooltip title={description}>
            <span style={{ cursor: 'pointer' }}>
              {API_ACTIVITY_STATUS[status]}
            </span>
          </Tooltip>
        )
      }

      if (!isCompleted(status)) {
        return API_ACTIVITY_STATUS[status]
      }
      if (!date) return '-'
      return dayjs(date).format('M/D/YYYY - h:mmA')
    },
  },
  {
    title: 'Original Data',
    dataIndex: 'originalData',
    render: (
      text: string,
      {
        originalDataUrl,
        status,
      }: Pick<CencusApiActivityDataType, 'originalDataUrl' | 'status'>
    ) => {
      if (isInProgress(status)) {
        return API_ACTIVITY_STATUS[status]
      }
      if (!Number(text) || !originalDataUrl) {
        return `${text} record`
      }
      return (
        <DownloadButton url={originalDataUrl}>{text} records</DownloadButton>
      )
    },
  },
  {
    title: 'Processed Data',
    dataIndex: 'processedData',
    render: (
      text: string,
      {
        processedDataUrl,
        status,
      }: Pick<CencusApiActivityDataType, 'processedDataUrl' | 'status'>
    ) => {
      if (isInProgress(status)) {
        return API_ACTIVITY_STATUS[status]
      }
      if (!Number(text) || !processedDataUrl) {
        return `${text} new`
      }
      return <DownloadButton url={processedDataUrl}>{text} new</DownloadButton>
    },
  },
]
